import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { useTranslation } from "react-i18next";

const DeductionDetailMain = () => {
  const { t } = useTranslation();
  const BelongTo = [
    { id: 0, name: "salary" },
    { id: 1, name: "penalty" },
    { id: 2, name: "Insurance Deduction" },
    { id: 2, name: "Other Deduction" }
  ];
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Description")} fieldName={"description"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupInput items={BelongTo} title={t("Deduction Type")} fieldName={"deductionType"} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("createdDate")} fieldName={"Created Date"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupAccount title={t("withholdingTaxRateId")} fieldName="withholdingTaxRateId" />
        </Col>
        <Col sm={6}>
          <NFLookupAccount title={t("SettlementsAccount")} fieldName="settlementsAccountId" />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupAccount title={t("WithHolding ax")} fieldName="withholdingTaxId" />
        </Col>
        <Col sm={3}>
          <NFLookupAccount title={t("PensionContributionAccount")} fieldName="pensionContributionAccountId" />
        </Col>
        <Col sm={3}>
          <NFLookupAccount title={t("Deduction")} fieldName="accountDeductionId" />
        </Col>
      </Row>
    </>
  );
};

export default DeductionDetailMain;
